module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/level-5_start-e1907bc5b43efa434ab461f9958e218a.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/level-5_start.png
// module id = 452
// module chunks = 2